import ReceiveAsset from './ReceiveAsset';

export default ReceiveAsset;
